const commonHeaders = {'X-Requested-With': 'XMLHttpRequest'};

class LegalTextService {
    getTos = (languageCode) => {
        return getLegalText('/api/legal/termsOfUse?languageCode=', languageCode);
    }
    getPrivacy = async (languageCode) => {
        return getLegalText('/api/legal/privacyNotice?languageCode=', languageCode);
    }  
}

function getLegalText(uri, languageCode, counter = 1)  {
    return fetch(uri + languageCode, {
        credentials: 'same-origin', 
        headers: {...commonHeaders}
    }).then((response) => {
        if (response && response.ok) {
            return response.json();
        }
        if (response && response.status === 400 && counter > 0) {
            counter--;
            return getLegalText(uri, 'en', counter);
        }
    }).catch(e => console.error('Unexpected error occurred on getting legal texts', e));
}

export default new LegalTextService();




// WEBPACK FOOTER //
// ./src/ConsentsLoginModal/LegalTextService.js